import firebase from 'firebase/compat/app';
import withoutNulls from '../api/search/withoutNulls';
import STORE_CONSTANTS from './constants';

const timelineEventConverter = {
  toFirestore(timelineEvent: Timeline.Event): firebase.firestore.DocumentData {
    return withoutNulls({ ...timelineEvent });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): Timeline.Event {
    const data = snapshot.data(options);
    return data as Timeline.Event;
  },
};

const getTimelineEventsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.TIMELINE_EVENT_COLLECTION)
    .withConverter(timelineEventConverter);
};

export default getTimelineEventsRef;
